import { Controller } from "@hotwired/stimulus"

// Mirrored ClickUp lists: a task row or card opens the task in Jane's
// app-wide side panel (shared/_note_sidebar) instead of jumping out to
// ClickUp. Each opener is a real link to the task in ClickUp, so cmd-click /
// middle-click still opens ClickUp in a new tab; a plain click opens the panel.
// Links INSIDE the panel (a subtask, the parent) use the same contract via the
// window event, so the panel can walk the task tree without a page load.
export default class extends Controller {
    static values = { openUrl: String, openTitle: String }

    // A link straight to one task (?task=, from search) opens its panel once
    // the page is up. Deferred a tick so the side panel's own controller has
    // connected and is listening.
    connect() {
        if (!this.openUrlValue) return
        this.element.querySelector(`[data-panel-url="${CSS.escape(this.openUrlValue)}"]`)
            ?.closest("[data-panel-row]")?.classList.add("is-panel-open")
        setTimeout(() => this._openPanel(this.openUrlValue, this.openTitleValue), 0)
    }

    open(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return
        // A link inside the row (an email, a URL field) keeps its own job.
        const inner = event.target.closest("a")
        if (inner && !inner.hasAttribute("data-panel-url")) return
        // The whole row is the target; its name link carries the panel URL.
        const opener = event.target.closest("[data-panel-url]") ||
            event.target.closest("[data-panel-row]")?.querySelector("[data-panel-url]")
        if (!opener) return

        event.preventDefault()
        this.element.querySelectorAll(".is-panel-open").forEach((el) => el.classList.remove("is-panel-open"))
        opener.closest("[data-panel-row]")?.classList.add("is-panel-open")
        this._openPanel(opener.dataset.panelUrl, opener.dataset.panelTitle)
    }

    _openPanel(url, title) {
        window.dispatchEvent(new CustomEvent("jane:open-panel", {
            detail: { url, title, icon: "bi-check2-square", label: "ClickUp task" }
        }))
    }
}
